export default __webpack_public_path__ + "39b7313dce077d4f3db513ff8cdbc5ad.png";